import Profile from "../../../components/company/profile";


const ProfilePage = () => {
    return <Profile />;
}

export default ProfilePage;